export default "__VITE_ASSET__BERF3n8e__"